<template>
  <div>
    <v-sheet
      id="dropzone"
      ref="dzone"
      tabindex="0"
      title="Click to grap a file from your PC!"
      width="100%"
      style="cursor: pointer"
      class="dropzone"
    >
      <input
        ref="upload"
        id="fileUpload"
        type="file"
        accept=".epub, .pdf"
        style="display: none"
      />
      <!--, .pdf, .lpf -->
      <v-container>
        <v-row justify="center">
          <v-icon v-if="!dragover" color="indigo darken-2" size="75"
            >mdi-cloud-upload-outline</v-icon
          >
          <v-icon v-if="dragover" color="indigo darken-2" size="75"
            >mdi-book-plus</v-icon
          >
        </v-row>
        <v-row justify="center">
          <span class="title indigo--text text--darken-2">{{
            selectedFile
          }}</span>
        </v-row>
        <v-row  v-show="selectedFile!='Drop an EPUB file here!'">
          <div class="col">
            <div justify="center"> <!--class="float-right"-->
              <v-btn class="ma-0" color="red" dark @click="removeFile">
                Remove
                <v-icon dark right> mdi-delete </v-icon>
              </v-btn>
            </div>
          </div>
        </v-row>
      </v-container>
    </v-sheet>
    <v-container>
      <v-row>
        <v-spacer></v-spacer>

        <v-spacer></v-spacer>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import Vue from "vue";
import { Emit } from "vue-property-decorator";

// internal properties

export default {
  //class FileDrop extends Vue
  name: "FileDrop",
  mounted() {
    // to register listeners, we have to know the
    // html elements
    this.dropzone = this.$el;
    this.fileupload = this.$el.firstElementChild; //as HTMLElement
    // register listeners on your dropzone / v-sheet
    if (dropzone) {
      // register all drag & drop event listeners
      dropzone.addEventListener("dragenter", (e) => {
        e.preventDefault();
        this.dragover = true;
      });
      dropzone.addEventListener("dragleave", (e) => {
        e.preventDefault();
        this.dragover = false;
      });
      dropzone.addEventListener("dragover", (e) => {
        e.preventDefault();
        this.dragover = true;
      });
      dropzone.addEventListener("drop", (e) => {
        e.preventDefault();
        const dragevent = e; //as DragEvent
        if (dragevent.dataTransfer) {
          //this.filesSelected(dragevent.dataTransfer.files);
          this.$emit("update", dragevent.dataTransfer.files);
        }
      });
      // register event listener for keyboard usage
      dropzone.addEventListener("click", (e) => {
        //e.preventDefault();
        if (this.fileupload) {
          this.fileupload.click();
        }
      });
      dropzone.addEventListener("keypress", (e) => {
        e.preventDefault();
        const keyEvent = e; //as KeyboardEvent
        if (keyEvent.key === "Enter") {
          if (fileupload) fileupload.click();
        }
      });
      // register listeners on the file input
      if (this.fileupload) {
        this.fileupload.addEventListener("change", (e) => {
          const target = e.target; // as HTMLInputElement
          fileCount = target.files.length;
          if (target.files) {
            // this.filesSelected(target.files);
            console.log("emit update target" + target);
            this.$emit("update", target.files);
          }
        });
      }
    }
  },
  props: {
    fileName: { type: Object, required: true },
  },
  watch: {
    fileName: function (val) {
      this.selectedFile = val; // + ' file added.';
    },
  },
  methods: {
    filesSelected(fileList) {
      this.dragover = false;
      console.log(fileList);
    },
    removeFile(e) {
      e.preventDefault();
      this.selectedFile = "Drop an EPUB or PDF file here!"
      this.$emit("clear");
    },
  },
  data() {
    return {
      formUpload: false,
      dragover: false,
      dropzone: "",
      fileupload: "",
      //selectedFile: "Drop an EPUB, PDF or LPF file here!",
      selectedFile: "Drop an EPUB or PDF file here!",
      fileCount: 0,
    };
  },
};
</script>




// WEBPACK FOOTER //
// src/components/FileDrop.vue